import React from 'react';
const Footer = () => {
  return <footer className="w-full bg-black text-white py-6 mt-auto" data-id="element-206">
      <div className="max-w-6xl mx-auto px-4" data-id="element-207">
        <div className="flex flex-col md:flex-row justify-between" data-id="element-208">
          <div className="mb-4 md:mb-0" data-id="element-209">
            <img src="https://cdn.shopify.com/s/files/1/0915/4058/6876/files/2_c25fbbee-f30c-45d2-b087-7e1fc46f23d4.png?v=1749850105" alt="Glowly" className="h-6 mb-2" data-id="element-210" />
            <p className="text-sm text-gray-300" data-id="element-211">
              Hajápolási tanácsok és innovatív megoldások
            </p>
          </div>
          <div className="grid grid-cols-2 gap-8" data-id="element-212">
            <div data-id="element-213">
              <h4 className="text-sm font-semibold mb-2" data-id="element-214">Kategóriák</h4>
              <ul className="text-xs text-gray-300 space-y-1" data-id="element-215">
                <li data-id="element-216">
                  <a href="#" className="hover:text-white" data-id="element-217">
                    Hajhullás
                  </a>
                </li>
                <li data-id="element-218">
                  <a href="#" className="hover:text-white" data-id="element-219">
                    Hajápolás
                  </a>
                </li>
                <li data-id="element-220">
                  <a href="#" className="hover:text-white" data-id="element-221">
                    Hajtípusok
                  </a>
                </li>
                <li data-id="element-222">
                  <a href="#" className="hover:text-white" data-id="element-223">
                    Kezelések
                  </a>
                </li>
              </ul>
            </div>
            <div data-id="element-224">
              <h4 className="text-sm font-semibold mb-2" data-id="element-225">Információk</h4>
              <ul className="text-xs text-gray-300 space-y-1" data-id="element-226">
                <li data-id="element-227">
                  <a href="#" className="hover:text-white" data-id="element-228">
                    Rólunk
                  </a>
                </li>
                <li data-id="element-229">
                  <a href="#" className="hover:text-white" data-id="element-230">
                    Kapcsolat
                  </a>
                </li>
                <li data-id="element-231">
                  <a href="#" className="hover:text-white" data-id="element-232">
                    Adatvédelem
                  </a>
                </li>
                <li data-id="element-233">
                  <a href="#" className="hover:text-white" data-id="element-234">
                    ÁSZF
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="mt-6 pt-4 border-t border-gray-700 text-xs text-gray-400 text-center" data-id="element-235">
          <p data-id="element-236">© 2023 Glowly. Minden jog fenntartva.</p>
          <p className="mt-1" data-id="element-237">
            Ez a tartalom kizárólag tájékoztató jellegű, nem helyettesíti a
            szakorvosi tanácsadást.
          </p>
        </div>
      </div>
    </footer>;
};
export default Footer;